import React, { useState } from "react";
import "./BookingSideBar.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import images from "../../../../Utils/importImages";
import Popup from "./BookingPopup";
import Invoice from "../Invoice";
import WebCheckin from "../WebCheckin";
import EmailTicket from "../EmailTicket";
import TicketFormat from "../TicketFormat";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactDOMServer from "react-dom/server";
import ReactDOM from "react-dom/client";

function BookingSideBar({ SidebarOptions }) {
  let dispatch = useDispatch();

  const { isUserLogin, isAdminLogin, userLoggedInData } = useSelector(
    (state) => state.user
  );

  console.log("userLoggedInData is : ", userLoggedInData);

  let navigate = useNavigate();

  let getTwoLetterName = () => {
    let name =
      isUserLogin == true
        ? `${userLoggedInData?.user_data?.[0]?.first_name} ${
            userLoggedInData?.user_data?.[0]?.last_name == null
              ? ""
              : userLoggedInData?.user_data?.[0]?.last_name
          }`
        : userLoggedInData?.fullName;

    let splitted = name.split(" ");

    let returnName = splitted.map((item) => item.charAt(0));

    return returnName;
  };

  let getName = () => {
    let name =
      isUserLogin == true
        ? `${userLoggedInData?.user_data?.[0]?.first_name} ${
            userLoggedInData?.user_data?.[0]?.last_name == null
              ? ""
              : userLoggedInData?.user_data?.[0]?.last_name
          }`
        : userLoggedInData?.fullName;
    return name;
  };

  let getContactInfo = () => {
    let credential =
      isUserLogin == true
        ? userLoggedInData?.auth_prime == "email"
          ? userLoggedInData?.email
          : userLoggedInData?.phone
        : userLoggedInData?.email;
    return credential;
  };

  const downloadTicket = async (data) => {
    // Create a hidden container
    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.top = "-10000px";
    container.style.left = "-10000px";
    container.style.width = "800px"; // Set appropriate width
    container.style.background = "#fff";
    document.body.appendChild(container);

    // Render component to container
    const element = <TicketFormat Data={data} nav={null} />;
    const htmlString = ReactDOMServer.renderToString(element);
    container.innerHTML = htmlString;

    // Wait for images/fonts to load (optional delay)
    await new Promise((res) => setTimeout(res, 1000));

    // Convert to canvas
    const canvas = await html2canvas(container, {
      scale: 2,
      useCORS: true,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("ticket.pdf");

    // Clean up
    document.body.removeChild(container);
  };

  let [openEmailTicketPopup, setOpenEmailTicketPopup] = useState(false);

  let [emailData, setEmailData] = useState(null);
  let closeTheEmailTicketPopup = () => {
    setEmailData(null);
    setOpenEmailTicketPopup(false);
  };

  let openTheEmailTicket = (data) => {
    setEmailData(data);
    setOpenEmailTicketPopup(true);
  };

  let [openInvoicePopup, setOpenInvoicePopup] = useState(false);

  let [invoiceData, setInvoiceData] = useState(null);

  let closeTheInvoicePopup = () => {
    setInvoiceData(null);
    setOpenInvoicePopup(false);
  };

  let openTheInvoice = (data) => {
    setInvoiceData(data);
    setOpenInvoicePopup(true);
  };

  let [openCheckinPopup, setOpenCheckinPopup] = useState(false);

  let [CheckinData, setCheckinData] = useState(null);
  let [CheckinLinks, setCheckinLinks] = useState(null);

  let closeTheCheckinPopup = () => {
    setCheckinData(null);
    setCheckinLinks(null);
    setOpenCheckinPopup(false);
  };

  let openTheWebCheckin = (links, data) => {
    setCheckinData(data);
    setCheckinLinks(links);
    setOpenCheckinPopup(true);
  };

  const printTicket = (data) => {
    const printWindow = window.open("", "_blank", "width=800,height=600");

    // Collect all stylesheets from the current document
    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          if (sheet.href) {
            return `<link rel="stylesheet" href="${sheet.href}" />`;
          } else if (sheet.ownerNode && sheet.ownerNode.innerHTML) {
            return `<style>${sheet.ownerNode.innerHTML}</style>`;
          }
        } catch (e) {
          console.warn("Style sheet couldn't be loaded:", e);
          return "";
        }
      })
      .join("\n");

    const htmlContent = `
        <html>
          <head>
            <title>Print Ticket</title>
            ${styles}
          </head>
          <body>
            <div id="print-ticket-root"></div>
            <script>
              window.onload = function () {
                setTimeout(() => {
                  window.print();
                  window.close();
                }, 1000);
              };
            </script>
          </body>
        </html>
      `;

    printWindow.document.write(htmlContent);
    printWindow.document.close();

    // Wait for window to finish loading before injecting React
    const interval = setInterval(() => {
      const rootEl = printWindow.document.getElementById("print-ticket-root");
      if (rootEl) {
        const root = ReactDOM.createRoot(rootEl);
        root.render(<TicketFormat Data={data} nav={null} />);
        clearInterval(interval);
      }
    }, 100);
  };

  return (
    <>
      <aside className="userdb-aside">
        <div className="userdb-logged-user">
          <div className="userdb-username-tag">{getTwoLetterName()}</div>
          <div className="userdb-username-info">
            <div className="userdb-uname">{getName()}</div>
            <div className="userdb-email">{getContactInfo()}</div>
          </div>
        </div>

        <div className="userdb-left-fb">
          <div className="element">
            <div className="bar"></div>
            <img src={images["flight-bookings-icon.svg"]} alt="" srcset="" />
            <div className="proxima_semibold color_dark-purple font16">
              My Flight Bookings
            </div>
          </div>
        </div>
        <ul className="userdb-left-panel booking-sidebar">
          {SidebarOptions?.map((option, id) => {
            return (
              <li
                className={option.classname}
                onClick={() => {
                  if (option.action == "download") {
                    downloadTicket(option.Data.data);
                  } else if (option.action == "print") {
                    let DataToSend = SidebarOptions.filter(
                      (item) => item.name == "Download E-Ticket"
                    )[0].Data.data;
                    printTicket(DataToSend);
                  } else if (option.action == "email") {
                    let DataToSend = SidebarOptions.filter(
                      (item) => item.name == "Download E-Ticket"
                    )[0].Data.data;

                    openTheEmailTicket(DataToSend);
                  } else if (
                    option.action == "popup" &&
                    option.name == "Invoice"
                  ) {
                    openTheInvoice(option?.Data || option?.data);
                    // openpopup // open the popup and sned email
                  } else if (option.action == "redirect") {
                    let DataToSend = SidebarOptions.filter(
                      (item) => item.name == "Download E-Ticket"
                    )[0].Data.data;

                    openTheWebCheckin(option.links, DataToSend);

                    // openpopup // open the popup and sned email
                  }
                }}
              >
                {option.name}
              </li>
            );
          })}
        </ul>
      </aside>

      <Popup
        Open={openEmailTicketPopup}
        onClose={closeTheEmailTicketPopup}
        component={
          <EmailTicket Data={emailData} onClose={closeTheEmailTicketPopup} />
        }
      />

      <Popup
        Open={openCheckinPopup}
        onClose={closeTheCheckinPopup}
        component={
          <WebCheckin
            Data={CheckinData}
            links={CheckinLinks}
            onClose={closeTheCheckinPopup}
          />
        }
      />

      <Popup
        Open={openInvoicePopup}
        onClose={closeTheInvoicePopup}
        component={
          <Invoice Data={invoiceData} onClose={closeTheInvoicePopup} />
        }
      />
    </>
  );
}

export default BookingSideBar;
